export default "__VITE_PUBLIC_ASSET__cdda8cf4__"